import React from "react";

import { Button } from "./Atoms";
import { useVenue } from "./VenueContext";

const OnlineMenuMessage = ({ onDismiss }: { onDismiss: () => void }) => {
  const venue = useVenue();
  const { activeMenuMessage } = venue.venueBrand;
  if (!activeMenuMessage) return null;
  return (
    <div className="mx-auto w-full max-w-sm space-y-16 rounded-venue-brand bg-venue-secondary p-12">
      <div className="flex">
        <div className="flex-1 text-xl">{activeMenuMessage.title}</div>
      </div>
      <div className="min-h-[96px] whitespace-pre-line">
        {activeMenuMessage.message}
      </div>
      <div>
        <Button primary onClick={onDismiss}>
          {activeMenuMessage.confirmationText}
        </Button>
      </div>
    </div>
  );
};

export default OnlineMenuMessage;
